<template>
 

  <div class="container put-right" style="direction:rtl">

      <h3 class="heading" style="display:initial;margin-left:2rem">الشكاوي</h3>
        <form style="display:initial;">
 <router-link to="/AddComplain"> <button type="button" class="btn btn-primary">اضافة</button> </router-link>
      </form>


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col"> مقدم الطلب </th>
      <th scope="col"> الاخ </th>
      <th scope="col"> نوع البلاغ  </th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >          
      <th scope="row" >{{keey.id}}</th>
      <td>       {{keey.presented}} </td>
      <td>       {{keey.clerk}} </td>
      <td>{{keey.complaint_type_name}}</td>
      <div class="right">
      <router-link :to="{ name: 'AccusedView', params: { id: keey.id}}"> <button   class="icon-button orange text-white" > 
        المتهمين
</button> </router-link>

      <router-link :to="{ name: 'ComplainPrint', params: { id: keey.id}}"> <button   class="icon-button orange text-white" >
       <!-- <img src="../../assets/printer.png" alt="" class="icon-small"> --> طباعة
</button> </router-link>
</div>
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:"ComplainView",
data(){
  return{
     formdata2:[], 
  }
},
mounted() {
  
 
    
       fetch(geturl()+"complaints/complaint/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data           
      })
    }
}
</script>

<style>

</style>